import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "vab-icon-right_line_84",
  "use": "vab-icon-right_line_84-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"vab-icon-right_line_84\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.4718 7.52852C10.7321 7.78885 10.7321 8.21098 10.4718 8.47132L6.70054 12.2426C6.44022 12.5029 6.01811 12.5029 5.75776 12.2426C5.49741 11.9822 5.49741 11.5601 5.75776 11.2997L9.05761 7.99992L5.75776 4.70008C5.49741 4.43974 5.49741 4.01762 5.75776 3.75728C6.01811 3.49692 6.44022 3.49692 6.70054 3.75728L10.4718 7.52852Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol